import { useState, useEffect } from 'react';
import { fetchProjectMilestoneGRActionItems } from '@gp/services/grActionItems';

import type { IProjectGRActionItem } from '@gp/types/grActionItems';

export default function useFetchGRActionItems(props: { execute: boolean; projectId?: string; milestoneId?: string }) {
  const { execute, projectId, milestoneId } = props;

  const [grActionItemsLoading, setGRActionItemsLoading] = useState(true);
  const [grActionItems, setGRActionItems] = useState<IProjectGRActionItem[]>([]);

  const updateGRActionItems = async (params: { projectId?: string; milestoneId?: string }) => {
    const { projectId, milestoneId } = params || {};
    if (!projectId || !milestoneId) return;

    try {
      const res = await fetchProjectMilestoneGRActionItems({
        project_id: projectId,
        milestone_id: milestoneId,
      });
      const { gr_action_items: grActionItems } = res?.data || {};
      const grActionItemsTmp = !Array.isArray(grActionItems) ? [] : grActionItems;
      setGRActionItems(grActionItemsTmp);
    } catch (exception) {
    } finally {
      setGRActionItemsLoading(false);
    }
  };

  useEffect(() => {
    if (!execute) {
      setGRActionItemsLoading(true);
      setGRActionItems([]);
      return;
    }
    updateGRActionItems({ projectId, milestoneId });
  }, [execute, projectId, milestoneId]);

  return { grActionItemsLoading, grActionItems };
}
